export default __webpack_public_path__ + "static/media/magick-home-2.003d6ed7.png";